import Api from "../ApiUtility/Api";

class DatasetDS {
  constructor() {
    this.api = new Api();
  }

  /** 1️⃣ INSERT DATASET **/
  AP_Dataset_INSERT(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Dataset_INSERT")
      .then((data) => {
        console.log("Dataset Insert Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Dataset Insert API call:", error);
        throw error;
      });
  }


  WS_Dataset_Bucket_CREATE(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Dataset_Bucket_CREATE")
      .then((data) => {
        console.log("Dataset Insert Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Dataset Insert API call:", error);
        throw error;
      });
  }

  /** 2️⃣ LIST GET — Paginated Dataset List **/
  AP_Dataset_List_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Dataset_List_GET")
      .then((data) => {
        console.log("Dataset List Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Dataset List GET API call:", error);
        throw error;
      });
  }

  /** 3️⃣ GET BY ID **/
  AP_Datasets_ById_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Datasets_ById_GET")
      .then((data) => {
        console.log("Dataset By ID Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Dataset GET BY ID API call:", error);
        throw error;
      });
  }

  /** 4️⃣ UPDATE DATASET **/
  AP_Dataset_UPDATE(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Dataset_UPDATE")
      .then((data) => {
        console.log("Dataset Update Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Dataset Update API call:", error);
        throw error;
      });
  }

  /** 5️⃣ DELETE DATASET **/
  AP_Dataset_DELETE(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Dataset_DELETE")
      .then((data) => {
        console.log("Dataset Delete Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Dataset Delete API call:", error);
        throw error;
      });
  }
  WS_CK_Schema_INSERT(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_CK_Schema_INSERT")
      .then((data) => {
        console.log("WS_CK_Schema_INSERT Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_CK_Schema_INSERT API call:", error);
        throw error;
      });
  }
  
}

export default DatasetDS;
